/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetWorkingTimes200ResponseLocationMondayInner } from './GetWorkingTimes200ResponseLocationMondayInner';
import {
    GetWorkingTimes200ResponseLocationMondayInnerFromJSON,
    GetWorkingTimes200ResponseLocationMondayInnerFromJSONTyped,
    GetWorkingTimes200ResponseLocationMondayInnerToJSON,
    GetWorkingTimes200ResponseLocationMondayInnerToJSONTyped,
} from './GetWorkingTimes200ResponseLocationMondayInner';

/**
 * 
 * @export
 * @interface GetWorkingTimes200ResponseLocation
 */
export interface GetWorkingTimes200ResponseLocation {
    /**
     * 
     * @type {Array<GetWorkingTimes200ResponseLocationMondayInner>}
     * @memberof GetWorkingTimes200ResponseLocation
     */
    monday: Array<GetWorkingTimes200ResponseLocationMondayInner>;
    /**
     * 
     * @type {Array<GetWorkingTimes200ResponseLocationMondayInner>}
     * @memberof GetWorkingTimes200ResponseLocation
     */
    tuesday: Array<GetWorkingTimes200ResponseLocationMondayInner>;
    /**
     * 
     * @type {Array<GetWorkingTimes200ResponseLocationMondayInner>}
     * @memberof GetWorkingTimes200ResponseLocation
     */
    wednesday: Array<GetWorkingTimes200ResponseLocationMondayInner>;
    /**
     * 
     * @type {Array<GetWorkingTimes200ResponseLocationMondayInner>}
     * @memberof GetWorkingTimes200ResponseLocation
     */
    thursday: Array<GetWorkingTimes200ResponseLocationMondayInner>;
    /**
     * 
     * @type {Array<GetWorkingTimes200ResponseLocationMondayInner>}
     * @memberof GetWorkingTimes200ResponseLocation
     */
    friday: Array<GetWorkingTimes200ResponseLocationMondayInner>;
    /**
     * 
     * @type {Array<GetWorkingTimes200ResponseLocationMondayInner>}
     * @memberof GetWorkingTimes200ResponseLocation
     */
    saturday: Array<GetWorkingTimes200ResponseLocationMondayInner>;
    /**
     * 
     * @type {Array<GetWorkingTimes200ResponseLocationMondayInner>}
     * @memberof GetWorkingTimes200ResponseLocation
     */
    sunday: Array<GetWorkingTimes200ResponseLocationMondayInner>;
}

/**
 * Check if a given object implements the GetWorkingTimes200ResponseLocation interface.
 */
export function instanceOfGetWorkingTimes200ResponseLocation(value: object): value is GetWorkingTimes200ResponseLocation {
    if (!('monday' in value) || value['monday'] === undefined) return false;
    if (!('tuesday' in value) || value['tuesday'] === undefined) return false;
    if (!('wednesday' in value) || value['wednesday'] === undefined) return false;
    if (!('thursday' in value) || value['thursday'] === undefined) return false;
    if (!('friday' in value) || value['friday'] === undefined) return false;
    if (!('saturday' in value) || value['saturday'] === undefined) return false;
    if (!('sunday' in value) || value['sunday'] === undefined) return false;
    return true;
}

export function GetWorkingTimes200ResponseLocationFromJSON(json: any): GetWorkingTimes200ResponseLocation {
    return GetWorkingTimes200ResponseLocationFromJSONTyped(json, false);
}

export function GetWorkingTimes200ResponseLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetWorkingTimes200ResponseLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'monday': ((json['monday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerFromJSON)),
        'tuesday': ((json['tuesday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerFromJSON)),
        'wednesday': ((json['wednesday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerFromJSON)),
        'thursday': ((json['thursday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerFromJSON)),
        'friday': ((json['friday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerFromJSON)),
        'saturday': ((json['saturday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerFromJSON)),
        'sunday': ((json['sunday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerFromJSON)),
    };
}

export function GetWorkingTimes200ResponseLocationToJSON(json: any): GetWorkingTimes200ResponseLocation {
    return GetWorkingTimes200ResponseLocationToJSONTyped(json, false);
}

export function GetWorkingTimes200ResponseLocationToJSONTyped(value?: GetWorkingTimes200ResponseLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'monday': ((value['monday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerToJSON)),
        'tuesday': ((value['tuesday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerToJSON)),
        'wednesday': ((value['wednesday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerToJSON)),
        'thursday': ((value['thursday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerToJSON)),
        'friday': ((value['friday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerToJSON)),
        'saturday': ((value['saturday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerToJSON)),
        'sunday': ((value['sunday'] as Array<any>).map(GetWorkingTimes200ResponseLocationMondayInnerToJSON)),
    };
}

